export enum Market {
    Unknown = 0,
    US = 1,
    UK = 2,
    DE = 3,
    FR = 4,
    IT = 6,
    IN = 7,
    ES = 8,
    CA = 9,
    MX = 11,
    AU = 13,
    NL = 14,
}

export const getCountryFlag = (market: number): string => {
    switch (market) {
        case Market.US:
            return "🇺🇸";
        case Market.UK:
            return "🇬🇧";
        case Market.DE:
            return "🇩🇪";
        case Market.FR:
            return "🇫🇷";
        case Market.IT:
            return "🇮🇹";
        case Market.IN:
            return "🇮🇳";
        case Market.ES:
            return "🇪🇸";
        case Market.CA:
            return "🇨🇦";
        case Market.MX:
            return "🇲🇽";
        case Market.AU:
            return "🇦🇺";
        case Market.NL:
            return "🇳🇱";
        default:
            return "🌐";
    }
};

export const getCountryName = (market: number): string => {
    switch (market) {
        case Market.US:
            return "United States";
        case Market.UK:
            return "United Kingdom";
        case Market.DE:
            return "Germany";
        case Market.FR:
            return "France";
        case Market.IT:
            return "Italy";
        case Market.IN:
            return "India";
        case Market.ES:
            return "Spain";
        case Market.CA:
            return "Canada";
        case Market.MX:
            return "Mexico";
        case Market.AU:
            return "Australia";
        case Market.NL:
            return "Netherlands";
        default:
            return "All Markets";
    }
};

export const getMarketLabel = (market: number): string => {
    return `${getCountryFlag(market)} ${getCountryName(market)}`;
};

export const getAmazonDomain = (market: number): string => {
    switch (market) {
        case Market.US:
            return "amazon.com";
        case Market.UK:
            return "amazon.co.uk";
        case Market.DE:
            return "amazon.de";
        case Market.FR:
            return "amazon.fr";
        case Market.IT:
            return "amazon.it";
        case Market.IN:
            return "amazon.in";
        case Market.ES:
            return "amazon.es";
        case Market.CA:
            return "amazon.ca";
        case Market.MX:
            return "amazon.com.mx";
        case Market.AU:
            return "amazon.com.au";
        case Market.NL:
            return "amazon.nl";
        default:
            return "amazon.com";
    }
};

export const getAmazonProductUrl = (asin: string, market: number): string => {
  const domain = getAmazonDomain(market);
  return `https://www.${domain}/dp/${asin}`;
};
